import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

// reducers
import ui from 'src/store/modules/ui'
import user from 'src/store/modules/user'
import patient from 'src/store/modules/patient'
import patients from 'src/store/modules/patients'
import company from 'src/store/modules/company'
import alerts from 'src/store/modules/alerts'
import openAlerts from 'src/store/modules/openAlerts'
import chats from 'src/store/modules/chats'
import actions from 'src/store/modules/actions'
import companiesAdministrating from 'src/store/modules/companiesAdministrating'
import admin from 'src/store/modules/admin'
import reports from 'src/store/modules/reports'
import common from 'src/store/modules/common'
import dashboard from 'src/store/modules/dashboard'
import caregiver from 'src/store/modules/caregiver'
import tasks from 'src/store/modules/tasks'

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    company,
    patient,
    patients,
    chats,
    user,
    ui,
    alerts,
    openAlerts,
    actions,
    companiesAdministrating,
    admin,
    reports,
    common,
    dashboard,
    caregiver,
    tasks
  })
